export default __webpack_public_path__ + "static/media/Design.b4fcdea3.svg";